import Vue from 'vue'
import App from './App.vue'
import router from './router/index'
Vue.config.productionTip = false

import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)

import axios from 'axios'
// axios请求的时候需要带上页面的cookie
axios.defaults.withCredentials = true
Vue.prototype.$ajax = axios

import XH from './vendors/xh'
Vue.prototype.$xh = XH

import api from './vendors/api'
Vue.prototype.$api = api

import { RSSign } from './vendors/sign'
Vue.prototype.$RSSign = RSSign

import VueCookies from 'vue-cookies'
Vue.use(VueCookies)

import toast from "./components/toast";
Vue.use(toast);

// 调试器
// import Vconsole from 'vconsole';
// new Vconsole();

new Vue({
  render: h => h(App),
  router,
}).$mount('#app')
